import { useEffect, useState } from "react";
import axios from "../api";

export default function PointsRules() {
  const [rules, setRules] = useState([]);
  useEffect(() => {
    axios.get("/users/points/rules").then(res => setRules(res.data.rules || []));
  }, []);
  return (
    <div className="points-rules">
      <h2>Punkte-Regeln</h2>
      <ul>
        {rules.map(rule => (
          <li key={rule.key}>
            <strong>{rule.label}:</strong> <span>+{rule.points} Punkte</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
